import { rem } from '@heathmont/moon-utils';
import styled from 'styled-components';
import useSite from '~/client/hooks/useSite';
import LazyLoad from '~/client/shared/LazyLoad';
import media from '~/client/shared/media';

type Props = {
  show: boolean;
};

const Container: FC<Props> = ({ children, show }) => {
  const { isSportsbet } = useSite();
  return (
    <TopBlock show={show} isSportsbet={isSportsbet}>
      <LazyLoad height={265}>{children}</LazyLoad>
    </TopBlock>
  );
};

type TopBlockProps = {
  show: boolean;
  isSportsbet: boolean;
  children: React.ReactNode;
};

const TopBlock = styled.div<TopBlockProps>`
  background-color: ${({ theme, isSportsbet }) =>
    isSportsbet ? theme.color.goku[100] : theme.color.gohan[100]};
  border-radius: ${({ theme }) => rem(theme.radius.default)};
  padding: ${({ theme }) => rem(theme.space.medium)};
  display: ${({ show }) => (show ? 'block' : 'none')};
  ${media.tabletSmall} {
    padding-bottom: ${rem(56)};
  }
  ${media.desktopSmall} {
    display: block;
    padding: ${({ theme }) => rem(theme.space.medium)};
  }
`;

export default Container;
